import React from 'react';
import ReactDOM from 'react-dom/client';
// Importing the Bootstrap CSS
//import 'bootstrap/dist/css/bootstrap.min.css';

import './index.css';
import App from './App';
import {Amplify} from 'aws-amplify';
import awsExports from './aws-exports';
Amplify.configure(awsExports);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
